import React from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import "./footer.css";

export const Footer = ({ orgInfo }) => {
  const { orgcode } = useParams();

  // Function to convert 24-hour time to 12-hour format with AM/PM
  const convertTo12HourFormat = (time) => {
    if (!time) return '';
    const [hours, minutes] = time.split(':');
    const parsedHours = parseInt(hours, 10);
    const period = parsedHours >= 12 ? 'PM' : 'AM';
    const formattedHours = parsedHours % 12 || 12; // Convert 0 to 12 for 12 AM
    return `${formattedHours}:${minutes} ${period}`;
  };

  return (
    <footer className="theme-eight-footer py-4">
      <div className="container">
        <div className="row">
          {/* Logo Section */}
          <div className="col-md-2">
            {orgInfo?.organization?.cloudR2ImagePath
 && (
              <img
                className="theme-eight-logo img-fluid"
                src={orgInfo?.organization?.cloudR2ImagePath
                  .getCDNUrl()}
                alt="Organization Logo"
                style={{ maxHeight: "90px" }}
              />
            )}
          </div>

          {/* Trading Hours Section */}
          <div className="col-md-3">
            <p className="mb-2 fs-4 text-black">Trading Hours</p>
            {orgInfo?.organization?.orgTradingHour?.length > 0 ? (
              <ul className="list-unstyled text-black">
                {orgInfo.organization.orgTradingHour.map((hour) => (
                  <li key={hour.id} className="mb-2">
                    <strong>{hour.dayOfWeek}:</strong> {convertTo12HourFormat(hour.openingTime)} - {convertTo12HourFormat(hour.closingTime)}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="m-0 text-black">No trading hours available.</p>
            )}
          </div>

          {/* Navigation Section */}
          <div className="col-md-2">
            <p className="mb-2 fs-4 text-black">Navigation</p>
            <ul className="list-unstyled">
              <li className="mb-1">
                <Link to={`/${orgcode}`} className="text-decoration-none text-dark">
                  Home
                </Link>
              </li>
              <li className="mb-1">
                <Link to={`/${orgcode}/about`} className="text-decoration-none text-dark">
                  About
                </Link>
              </li>
              <li className="mb-1">
                <Link to={`/${orgcode}/food-menu`} className="text-decoration-none text-dark">
                  Menu
                </Link>
              </li>
              <li className="mb-1">
                <Link to={`/${orgcode}/contact`} className="text-decoration-none text-dark">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Section */}
          <div className="col-md-2">
            <p className="mb-2 fs-4 text-black">Let's Talk</p>
            <p className="m-0 text-dark">
              <strong>Email:</strong> {orgInfo?.organization?.email || "N/A"}
            </p>
            <p className="m-0 text-dark">
              <strong>Contact:</strong> {orgInfo?.organization?.tel || "N/A"}
            </p>
            <p className="m-0 text-dark">
              <strong>Website:</strong> {orgInfo?.organization?.website || "N/A"}
            </p>
            <p className="m-0 text-dark">
              <strong>Address:</strong> {orgInfo?.organization?.address1 || "N/A"}
            </p>
          </div>

          {/* Follow Us Section */}
          <div className="col-md-3 text-start">
            <p className="fs-5 mb-1 text-black">Follow Us</p>
            <div className="d-flex gap-3">
              <a href="#" className="text-decoration-none" aria-label="Facebook">
                <i className="ri-facebook-fill fs-5 text-black"></i>
              </a>
              <a href="#" className="text-decoration-none" aria-label="Instagram">
                <i className="ri-instagram-fill fs-5 text-black"></i>
              </a>
              <a href="#" className="text-decoration-none" aria-label="Twitter">
                <i className="ri-twitter-fill fs-5 text-black"></i>
              </a>
              <a href="#" className="text-decoration-none" aria-label="YouTube">
                <i className="ri-youtube-fill fs-5 text-black"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        {/* <div className="text-center mt-4">
          <small className="text-muted">
            &copy; {new Date().getFullYear()} {orgInfo?.organization?.name || "Your Organization Name"}. All rights reserved.
          </small>
        </div> */}
      </div>
    </footer>
  );
};